import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Employee } from '../../../types/Employee';
import { Event, EventEmployee } from '../../../types/Event';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { EmployeeFilterParam } from './useGetAllEmployees';
import { AttendanceStatusFilter } from '../../../types/Event';

export type ScheduledEventEmployee = Pick<EventEmployee, 'status' | 'checked_in_at' | 'checked_out_at'> & {
  employee_uuid: Employee['uuid'];
  event: Event;
};

export interface ScheduledEmployeeEventsResponse {
  employees: Employee[];
  event_employees: ScheduledEventEmployee[];
}

export interface UseGetScheduledEmployeeEventsParams {
  date_range: string[];
  filters?: EmployeeFilterParam & {
    with_events?: boolean;
    attendance_status?: AttendanceStatusFilter;
  };
}

export interface UseGetScheduledEmployeeEventsProps {
  params?: UseGetScheduledEmployeeEventsParams;
  enabled?: boolean;
}

const fetchScheduledEmployeeEvents = async (params?: UseGetScheduledEmployeeEventsParams): Promise<ScheduledEmployeeEventsResponse> => {
  const { data } = await CustomAxios.get<ScheduledEmployeeEventsResponse>('employees/schedule', { params });

  return data;
};

export function useGetScheduledEmployeeEvents({ params, enabled = true }: UseGetScheduledEmployeeEventsProps) {
  return useQuery<ScheduledEmployeeEventsResponse, AxiosError<{ error: string }>>({
    enabled,
    queryKey: [queryKeys.allEmployees, 'schedule', params],
    queryFn: () => fetchScheduledEmployeeEvents(params),
    placeholderData: keepPreviousData,
  });
}
